import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { usersActions } from '../actions/users.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class UsersEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getUsers$ = createEffect(() => {
        return this.actions.pipe(
            ofType(usersActions.getUsers),
            mergeMap(() => {
                return this.httpService.getUsers().pipe(
                    finalizeLoader('users-get'),
                    map((users) => usersActions.getUsersSuccess({ users })),
                    catchError(() => of(usersActions.getUsersError())),
                );
            }),
        );
    });
}
